import { render } from "./OutboundAwareness.vue?vue&type=template&id=c8475162&scoped=true"
import script from "./OutboundAwareness.vue?vue&type=script&lang=js"
export * from "./OutboundAwareness.vue?vue&type=script&lang=js"

import "./OutboundAwareness.vue?vue&type=style&index=0&id=c8475162&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8475162"]])

export default __exports__